import anime from 'animejs'

export const handleMenuOverlayEnter = (el, done) => {
  document.body.classList.add('overflow-hidden')
  // Animate overlay
  anime({
    targets: el,
    opacity: [0, 1],
    duration: 400,
    easing: 'easeOutCubic',
    complete: done
  })

  // Animate menu items
  const children = el.querySelectorAll('[data-menu-item]')
  anime({
    targets: children,
    opacity: [0, 1],
    translateX: [-80, 0],
    duration: 400,
    easing: 'easeOutCubic',
    delay: function(el, i, l) {
      return 300 + i * 40
    },
    complete: () => {
      Array.from(children).forEach(child => child.removeAttribute('style'))
    }
  })
}

export const handleMenuOverlayLeave = (el, done) => {
  document.body.classList.remove('overflow-hidden')

  const children = el.querySelectorAll('[data-menu-item]')
  anime({
    targets: children,
    opacity: [1, 0],
    translateX: [0, -20],
    duration: 300,
    easing: 'easeOutCubic'
  })

  anime({
    targets: el,
    opacity: [1, 0],
    duration: 400,
    easing: 'easeOutCubic',
    complete: done,
    delay: 100
  })
}
